import React from 'react';

// Homepage instrument. One outlined rack (agentOS) runs from the inputs
// through a slotted gate to both forks. Gold is only the flow line.
// Page black shows through the frame. Do not invert: gold turns muddy brown.
// hero-joined.png and hero-agentic.jpg stay in /art. They are a different
// sentence (machines, no gate) and do not belong back on this hero.

const GOLD = '#C4A046';
const LINE = '#D5E0EE';
const LABEL = '#E7EEF6';

export default function HeroChassis() {
  return (
    <svg
      className="cs-hero-chassis"
      viewBox="0 0 840 336"
      role="img"
      aria-labelledby="heroChassisTitle"
      fill="none"
      stroke={LINE}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fontSize="13"
      fontFamily="-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif"
    >
      <title id="heroChassisTitle">
        A document, a message, and a record enter one chassis. The line stops
        at a gate, then continues to a system you already run, or to App Kit.
      </title>

      <g id="chassis">
        <rect x="72" y="118" width="12" height="52" rx="2" />
        <rect x="84" y="12" width="740" height="308" rx="18" />
        <rect x="824" y="118" width="12" height="52" rx="2" />
      </g>

      <g id="inputs">
        <path d="M6 52 h18 l10 10 v30 h-28 z M24 52 v10 h10" />
        <path d="M6 128 h32 a5 5 0 0 1 5 5 v12 a5 5 0 0 1 -5 5 h-18 l-8 7 v-7 h-6 a5 5 0 0 1 -5 -5 v-12 a5 5 0 0 1 5 -5 z" />
        <rect x="6" y="200" width="36" height="24" rx="4" />
        <path d="M14 209 h20 M14 217 h12" />
        <path d="M42 72 H130" stroke={GOLD} />
        <path d="M48 148 H130" stroke={GOLD} />
        <path d="M42 212 H130" stroke={GOLD} />
        <path d="M130 72 V212" stroke={GOLD} />
        <path d="M130 148 H508" stroke={GOLD} />
      </g>

      <g id="nqube">
        <rect x="156" y="58" width="40" height="32" rx="4" />
        <rect x="204" y="58" width="40" height="32" rx="4" />
        <rect x="252" y="58" width="40" height="32" rx="4" />
        <rect x="300" y="58" width="40" height="32" rx="4" />
        <text x="248" y="112" textAnchor="middle" fill={LABEL} stroke="none">nQube</text>
      </g>

      <g id="agentio">
        <text x="268" y="34" textAnchor="middle" fill={LABEL} stroke="none">Agent IO</text>
        <circle cx="224" cy="48" r="5" />
        <circle cx="272" cy="48" r="5" />
        <circle cx="320" cy="48" r="5" />
        <path d="M229 48 H267 M277 48 H315" />
        <path d="M325 48 H356" />
        <rect x="356" y="32" width="108" height="36" rx="10" />
        <path d="M370 46 h62 M370 56 h36" />
        <text x="410" y="108" textAnchor="middle" fill={LABEL} stroke="none">nventr Agent</text>
      </g>

      <g id="gate">
        <rect x="540" y="100" width="24" height="42" rx="3" />
        <rect x="540" y="154" width="24" height="42" rx="3" />
        <circle cx="552" cy="116" r="5" />
        <path d="M542 134 q10 -12 20 0" />
        <path d="M544 168 h16 M548 178 h8 M550 188 h4" />
        <path d="M544 148 H560" stroke={GOLD} />
        <path d="M592 148 H612" stroke={GOLD} />
      </g>

      <g id="system">
        <path d="M612 148 C 660 148, 668 96, 700 78" stroke={GOLD} />
        <ellipse cx="742" cy="56" rx="34" ry="9" />
        <path d="M708 56 v34 a34 9 0 0 0 68 0 v-34" />
        <ellipse cx="742" cy="56" rx="34" ry="9" />
        <text x="742" y="132" textAnchor="middle" fill={LABEL} stroke="none">Your system</text>
      </g>

      <g id="appkit">
        <path d="M612 148 C 660 148, 668 196, 692 204" stroke={GOLD} />
        <rect x="692" y="192" width="108" height="24" rx="6" />
        <circle cx="706" cy="204" r="3" />
        <path d="M714 204 h72" />
        <ellipse cx="746" cy="232" rx="16" ry="5" />
        <path d="M730 232 v14 a16 5 0 0 0 32 0 v-14" />
        <ellipse cx="746" cy="232" rx="16" ry="5" />
        <rect x="732" y="258" width="28" height="6" rx="1.5" />
        <rect x="724" y="266" width="44" height="6" rx="1.5" />
        <rect x="716" y="274" width="60" height="6" rx="1.5" />
        <text x="746" y="298" textAnchor="middle" fill={LABEL} stroke="none">App Kit</text>
      </g>
    </svg>
  );
}
